import React, { useState, useEffect } from "react";

// Función para eliminar tildes y caracteres especiales
const eliminarTildes = (texto) => {
    return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
};

const Buscador = ({ setBusqueda , setCantidadProductosMostrados}) => {
    const [inputValue, setInputValue] = useState("");
    const [mostrarError, setMostrarError] = useState(false);

    // Debounce: espera a que el usuario deje de tipear antes de filtrar la lista.
    // Esto evita re-renderizar todos los productos en cada tecla.
    useEffect(() => {
        const timer = setTimeout(() => {
            if (inputValue.length === 0 || inputValue.length >= 2) {
                setBusqueda(eliminarTildes(inputValue));
                setMostrarError(false);
                setCantidadProductosMostrados(50);
            } else if (inputValue.length === 1) {
                setMostrarError(true);
            }
        }, 300); // 300ms de debounce

        return () => clearTimeout(timer);
    }, [inputValue, setBusqueda, setCantidadProductosMostrados]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    const limpiarBusqueda = () => {
        setInputValue("");
        setBusqueda("");
        setMostrarError(false);
        setCantidadProductosMostrados(50);
    };

    return (
        <div className="buscadorContenedor">
            <label htmlFor="buscador-input">Buscar producto:</label>
            <div className="buscador">
                <input 
                    id="buscador-input"
                    type="text" 
                    placeholder="Ej: Perlas" 
                    value={inputValue} 
                    onChange={handleChange}
                />
                {inputValue && (
                    <button className="boton-limpiar" onClick={limpiarBusqueda}>
                        ✖
                    </button>
                )}
            </div>
            <p className={`mensaje-error ${mostrarError ? "" : "mensaje-error-oculto"}`}>Mínimo 2 letras para buscar</p>
        </div>
    );
};

export default Buscador;